module.exports = __webpack_public_path__ + "media/images/contact_small-acb58b1be27ada374c6e93ccb0172ad9.jpg";